import { Injectable } from '@angular/core';
import {CanActivate, UrlTree, Router} from '@angular/router';
import {AuthService} from '../user-services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GuestCanActivateGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const user = await this.authService.userManager.getUser();
    return user && !user.expired
      ? this.router.createUrlTree(['/menu/home'])
      : true;
  }
}
